import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/DISCOUNTS`;
export const REDUCER_NAME = 'discounts';
export const FORM_NAME = 'DISCOUNTS';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/pricing/discounts/:shipperId`;
